import Error404 from "components/patterns/error404";

export default Error404;
